module.exports = __webpack_public_path__ + "img/aprove-white.a5513da9.svg";